import { createContext } from "react";

const PortalContext = createContext(null);

export default PortalContext;